<template>
  <v-list class="pa-0">
    <v-subheader>
      <v-icon class="mr-3">account_circle</v-icon>
      {{ user ? user.name : generateMessage('boilerplate.unknown_user') }}
    </v-subheader>
    <v-divider></v-divider>
    <v-list-item
      v-for="(item, index) in items"
      @click="item.click"
      ripple="ripple"
      rel="noopener"
      :key="index"
      :href="item.href"
      :target="item.target"
    >
      <v-list-item-action v-if="item.icon">
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ generateMessage(item.title) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'c-setting-list',
  data: () => ({
    items: [],
  }),
  created() {
    this.setItem();
  },
  computed: {
    authenticated: {
      get() {
        return this.isAuthenticated();
      },
      set(val) {
        const loginItem = this.items.find((obj) => obj.id === 'login');
        loginItem.title = val ? 'boilerplate.logout' : 'boilerplate.login';
        loginItem.click = val ? this.logout : this.login;
      },
    },
    ...mapGetters({ user: 'global/user' }),
    ...mapGetters({ darkThemeEnabled: 'boilerplate/darkThemeEnabled' }),
    ...mapGetters({
      scrollOffNavbarEnabled: 'boilerplate/scrollOffNavbarEnabled',
    }),
  },
  watch: {
    darkThemeEnabled(enabled) {
      const themeItem = this.items.find((obj) => obj.id === 'theme');
      themeItem.title = this.getThemeTitle(enabled);
    },
    scrollOffNavbarEnabled(enabled) {
      const themeItem = this.items.find((obj) => obj.id === 'scrollOffNavbar');
      themeItem.title = this.getScrollOffNavbarTitle(enabled);
    },
  },
  methods: {
    setItem() {
      this.items = [
        {
          id: 'login',
          icon: 'exit_to_app',
          href: '#',
          title: 'boilerplate.logout',
          click: this.logout,
        },
        {
          id: 'theme',
          icon: 'wb_sunny',
          href: '#',
          title: this.getThemeTitle(this.darkThemeEnabled),
          click: this.toggleDarkTheme,
        },
        {
          id: 'scrollOffNavbar',
          icon: 'border_horizontal',
          href: '#',
          title: this.getScrollOffNavbarTitle(this.scrollOffNavbarEnabled),
          click: this.toggleScrollOffNavbar,
        },
        {
          id: 'resetPreferences',
          icon: 'mdi-lock-reset',
          href: '#',
          title: 'boilerplate.resetPreferences',
          click: this.resetPreferences,
        },
        {
          id: 'FAQ',
          icon: 'mdi-frequently-asked-questions',
          href: process.env.FAQ_LINK_URL,
          target: 'blank',
          title: 'boilerplate.FAQ_link',
          click: () => {},
        },
        {
          id: 'sharepoint',
          icon: 'mdi-microsoft-sharepoint',
          href: process.env.SHAREPOINT_LINK_URL,
          target: 'blank',
          title: 'boilerplate.MYP_portal_link',
          click: () => {},
        },
        {
          id: 'yammer',
          icon: 'mdi-microsoft-yammer',
          href: process.env.YAMMER_LINK_URL,
          target: 'blank',
          title: 'boilerplate.yammer_link',
          click: () => {},
        },
      ];
    },
    async isAuthenticated() {
      this.authenticated = await this.$auth.isAuthenticated();
    },
    toggleDarkTheme() {
      this.$store.dispatch('boilerplate/toggleDarkTheme');
    },
    toggleScrollOffNavbar() {
      this.$store.dispatch('boilerplate/toggleScrollOffNavbar');
    },
    resetPreferences() {
      window.localStorage.clear();
    },
    async logout() {
      await this.$store.dispatch('global/setUser', null);
      await this.$store.dispatch('boilerplate/setAuthenticated', false);
      await this.$auth.signOut();
    },
    async login() {
      await this.$store.dispatch('boilerplate/setAuthenticated', true);
      await this.$auth.signInWithRedirect({
        originalUri: '/',
        scopes: ['openid', 'profile'],
      });
    },
    setLanguage(language) {
      this.$store.dispatch('boilerplate/setLanguage', language);
    },
    getThemeTitle(darkThemeEnabled) {
      return darkThemeEnabled ? 'boilerplate.light' : 'boilerplate.dark';
    },
    getScrollOffNavbarTitle(scrollOffNavbarEnabled) {
      return scrollOffNavbarEnabled
        ? 'boilerplate.scrollOffNavbarOff'
        : 'boilerplate.scrollOffNavbarOn';
    },
    generateMessage,
  },
};
</script>
